import _ from 'underscore';
import Backbone from 'backbone';
import Global from 'models/Global';
import Config from '../config/isomorphic-config';
import backboneValidation from 'backbone-validation';
import {simpleProfileUrl} from '@bizzabo/linkedin-utils';

_.extend(Backbone.Validation.patterns, {
    email2: /^[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
});

const urlSetter = function(value) {
    const valueWithHTTP = 'http://' + value;
    return (Backbone.Validation.patterns.url.test(valueWithHTTP)) ? valueWithHTTP : value;
};

const Me = Backbone.Model.extend({
    urlRoot: '/api/v2/userProfile',
    url: '/api/v2/userProfile',

    initialize: function(options) {
        options = options || {};
        this.getToken = options.getToken || _.noop;
        this.noJoin = options.noJoin;

        _.bindAll(this, 'fetchBadge');
        this.preloadNewMessageSound();
        if (this.get('isJoined')) {
            this.openSocket();
        } else {
            this.listenTo(this, 'change:isJoined', this.openSocket);
        }
        this.listenTo(Backbone, 'linkedin-connect-success', this.linkedinConnectSuccess);
    },

    openSocket: function() {
        if (this.get('isJoined') && !this.emittedCoockie) {
            // TODO: test this token message
            Backbone.trigger('socketEmit', Config.authCookieAccess, {'token': this.getToken()});
            Backbone.trigger('socketOn', 'badge', this.fetchBadge);
            this.emittedCoockie = true;
            this.listenTo(Backbone, 'fetchBadge', this.fetchBadge);
        }
    },

    fetchBadge: function() {
        this.fetchUnreadCount(Global.get('eventId'));
    },

    defaults: {},

    set: function(key, value, options) {
        if (key === null) {
            return this;
        }

        let attrs = {};
        if (typeof key === 'object') {
            attrs = key;
            options = value;
        } else {
            (attrs = {})[key] = value;
        }

        for (const attr in attrs) {
            if (_.isFunction(this.setters[attr])) {
                attrs[attr] = this.setters[attr].call(this, attrs[attr]);
            }
        }

        return Backbone.Model.prototype.set.call(this, attrs, options);
    },

    setters: {
        web: urlSetter,
        blog: urlSetter,
        linkedinProfile: function(value) {
            let linkedinInfo = {};
            if (value) {
                try {
                    linkedinInfo = JSON.parse(value);
                } catch (e) {
                    linkedinInfo = {};
                }
            }
            this.set('linkedinInfo', linkedinInfo);
            return value;
        }
    },

    hasLinkedin: function() {
        const hasLinkedin = !!this.get('linkedInId');
        const valid = (this.get('invalid-linkedin-token') ? false : true);
        return (hasLinkedin && valid);
    },

    hasTwitter: function() {
        return !!this.get('twitterId');
    },

    hasFacebook: function() {
        return !!this.get('facebookId');
    },

    preloadNewMessageSound: function() {
        try {
            this.newMessageSound = new Audio('/sounds/nice_ping.mp3');
        } catch (e) {
            // No browser support
            this.newMessageSound = undefined;
        }
    },

    fetchUnreadCount: function(eventId) {
        const thisModel = this;
        const success = function(model) {

            if (model && thisModel.get('unread-count') &&
                ((parseInt(model.messages, 10) > parseInt(thisModel.get('unread-count').messages, 10)) ||
                    (parseInt(model.notifications, 10) > parseInt(thisModel.get('unread-count').notifications, 10)))) {
                thisModel.newMessageSound && thisModel.newMessageSound.play();
            }

            model && thisModel.set('unread-count', model);
        };
        Backbone.ajax({
            url: Config.baseV2Url + '/messages/unread/count?eventId=' + eventId,
            method: 'GET',
            success: success,
            error: success
        });
    },

    rsvp: function(join, eventID, options) {
        const prefix = join ? 'join' : 'leave';
        const thisModel = this;
        options = options || {};

        if (!eventID || !this.id) {
            options.error && options.error();
            return;
        }

        const success = options.success;
        options.success = function() {
            thisModel.set('isJoined', join);
            thisModel.trigger(prefix + '-success');
            success && success();
            thisModel.set('isLoading', false);
        };

        const error = options.error;
        options.error = function(data) {
            const errorCode = (data.error && data.error['error-code']) || 0;
            thisModel.trigger(prefix + '-error', errorCode);
            error && error(errorCode);
            thisModel.set('isLoading', false);
        };

        this.set('isLoading', true);

        Backbone.ajax({
            url: Config.baseV2Url + '/community/' + eventID,
            method: join ? 'POST' : 'DELETE',
            success: options.success,
            error: options.error
        });
    },

    join: function(eventID, options) {
        this.rsvp(true, eventID, options);
    },

    leave: function(eventID, options) {
        this.rsvp(false, eventID, options);
    },

    authorize: function(eventID, accessCode, options) {
        const thisModel = this;
        options = options || {};

        if (!eventID || !this.id) {
            options.error && options.error();
            return;
        }

        const success = options.success;
        options.success = function() {
            thisModel.trigger('authorize-success');
            success && success();
            thisModel.set('isLoading', false);
        };

        const error = options.error;
        options.error = function(data) {
            const errorCode = (data.error && data.error['error-code']) || 0;
            thisModel.trigger('authorize-error', errorCode);
            error && error(errorCode);
            thisModel.set('isLoading', false);
        };

        this.set('isLoading', true);
        Backbone.ajax({
            url: Config.baseV2Url + '/community/' + eventID + '?code=' + encodeURIComponent(accessCode),
            method: 'POST',
            success: options.success,
            error: options.error
        });
    },

    isJoined: function(eventID, options) {
        const thisModel = this;
        options = options || {};

        if (!eventID || !this.id) {
            options.error && options.error();
            return;
        }

        const success = options.success;
        options.success = function(response) {
            success && success(response);
            thisModel.set('isLoading', false);
        };

        const error = options.error;
        options.error = function(data) {
            const errorCode = (data.error && data.error['error-code']) || 0;
            error && error(errorCode);
            thisModel.set('isLoading', false);
        };

        this.set('isLoading', true);

        Backbone.ajax({
            url: `${Config.baseV2Url}/community/${eventID}`,
            method: 'GET',
            success: options.success,
            error: options.error
        });
    },

    checkIfSeenTutorial: function(options) {
        options = options || {};

        Backbone.ajax({
            url: Config.baseV2Url + '/userProfile/tutorial',
            method: 'GET',
            success: function(response) {
                options.success && options.success(response.tutorial);
            }
        });

    },

    requestAuthorize: function(eventID, options) {
        const thisModel = this;
        options = options || {};

        if (!eventID || !this.id) {
            options.error && options.error();
            return;
        }

        const success = options.success;
        options.success = function() {
            thisModel.set('requestPendingApproval', true);
            thisModel.trigger('request-authorize-success');
            success && success();
            thisModel.set('isLoading', false);
        };

        const error = options.error;
        options.error = function(data) {
            const errorCode = (data.error && data.error['error-code']) || 0;
            thisModel.trigger('request-authorize-error', errorCode);
            error && error(errorCode);
            thisModel.set('isLoading', false);
        };

        this.set('isLoading', true);
        Backbone.ajax({
            url: `${Config.baseV2Url}/community/${eventID}/private`,
            method: 'POST',
            success: options.success,
            error: options.error
        });
    },
    setLinkedinData: function(linkedinProfile) {
        const information = _.chain(linkedinProfile)
            .omit(function(value) {
                return _.isUndefined(value) || _.isNull(value);
            })
            .pick(['title', 'company', 'country', 'photoUrl', 'blog', 'web', 'summary', 'firstName', 'lastName', 'linkedinProfile'])
            .value();
        this.set(information);
        this.set('linkedInId', linkedinProfile.id);
        Backbone.trigger('linkedin-id-updated', linkedinProfile.id);

    },

    verifyLinkedinToken: function(options) {
        const thisModel = this;
        options = options || {};

        const baseUrl = '/api/v2/userProfile/socialNetwork/linkedin/get?url=';
        const linkedinUrl = simpleProfileUrl;

        const success = options.success;
        options.success = function(result) {
            if (result && result.id) {
                thisModel.set('invalid-linkedin-token', false);
                success && success();
            } else {
                thisModel.set('invalid-linkedin-token', true);
                options.error && options.error();
            }
        };

        Backbone.ajax({
            url: baseUrl + encodeURIComponent(linkedinUrl),
            method: 'GET',
            success: options.success,
            error: options.error
        });
    },

    _validate: _.wrap(Backbone.Model.prototype._validate, function(func, attrs, options) {
        options.validate = true;
        return func.call(this, attrs, options);
    }),

    validation: {
        primaryEmail: [
            {
                required: true,
                msg: 'Email is required'
            }, {
                pattern: 'email2',
                msg: 'Email is incorrect'
            }
        ],
        password: [
            {
                required: function(value, attr, computedState) {
                    return (computedState.provider == 'bizzabo');
                },
                msg: 'Password is required'
            },
            {
                rangeLength: [6, 24],
                msg: 'Password should be 6-24 characters'
            }
        ],
        firstName: [
            {
                required: true,
                msg: 'First name is required'
            }, {
                maxLength: 50,
                msg: 'First name is too long'
            }
        ],
        lastName: [
            {
                required: true,
                msg: 'Last name is required'
            }, {
                maxLength: 50,
                msg: 'Last name is too long'
            }
        ],
        company: [
            {
                required: false,
                maxLength: 150,
                msg: 'Organization is too long'
            }
        ],
        title: [
            {
                required: false,
                maxLength: 150,
                msg: 'Job title is too long'
            }
        ],
        oneLiner: {
            required: false,
            maxLength: 80,
            msg: 'One liner is too long'
        },
        web: {
            required: false,
            pattern: 'url',
            msg: 'Website is incorrect'
        },
        blog: {
            required: false,
            pattern: 'url',
            msg: 'Website is incorrect'
        },
        summary: {
            required: false,
            maxLength: 2000,
            msg: 'Summary is too long'
        }
    },

    linkedinConnectSuccess: function(data) {
        if (data.id) {
            this.set('linkedInId', data.id);
        }
    },

    fetch: function(options) {
        options = options || {};
        const originalSuccess = options.success;

        options.success = function(model, response, opts) {
            const event = Global.get('event');
            const communityVersion = event?.get('features')?.communityVersion;

            if (communityVersion === 'PEOPLE_V2' && model.get('id') && event?.get('id')) {
                Backbone.ajax({
                    url: `${Config.baseV2Url}/people/events/${event.get('id')}/profiles/me`,
                    method: 'GET',
                    success: function(peopleResponse) {
                        if (peopleResponse && peopleResponse.attributes) {
                            const photoUrl = peopleResponse.attributes.find(
                                attr => attr.key === 'thumbnailUrl'
                            )?.value;

                            if (photoUrl) {
                                model.set('photoSet', {
                                    small: photoUrl,
                                    medium: photoUrl,
                                    large: photoUrl
                                });
                                model.trigger('sync', model, peopleResponse, opts);

                            }
                        }
                        originalSuccess && originalSuccess(model, response, opts);
                    },
                    error: function() {
                        originalSuccess && originalSuccess(model, response, opts);
                    }
                });
            } else {
                originalSuccess && originalSuccess(model, response, opts);
            }
        };

        return Backbone.Model.prototype.fetch.call(this, options);
    },

});

export default Me;

